import { render } from "./InspectionBefore.vue?vue&type=template&id=31fffe7d"
import script from "./InspectionBefore.vue?vue&type=script&lang=js"
export * from "./InspectionBefore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__